import React from 'react';
import classNames from 'classnames';

import './AlphabeticalColumns.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  header: string;
}

export const AlphabeticalColumns: React.FC<Props> = ({ header, children, className, ...rest }) => (
  <div className={classNames('AlphabeticalColumns', className)} {...rest}>
    <header className="AlphabeticalColumns__header">{header}</header>

    <div className="AlphabeticalColumns__content">{children}</div>
  </div>
);
